<template>
	<portal>
		<div class="background" @click.stop="close">
			<Card class="modal" @click.native.stop>
				<div class="close">
					<Action title="Close" @click="close">
						<IconClose />
					</Action>
				</div>
				<div class="content">
					<h2 v-if="title" class="title">{{ title }}</h2>
					<slot />
				</div>
			</Card>
		</div>
	</portal>
</template>

<script>
import IconClose from 'mdi-vue/Close'
import Card from '@/components/Card'
import Action from '@/components/Action'

export default {
	name: 'Modal',
	props: {
		title: String,
	},
	methods: {
		close() {
			this.$emit('close')
		},
	},
	components: {
		Card,
		Action,
		IconClose,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/components';

.background {
	@extend %modal;
	overflow-y: auto;

	.modal {
		position: relative;
		margin: auto;
		width: calc(100vw - 3rem);
		max-width: 40rem;

		.close {
			position: absolute;
			top: 0.5rem;
			right: 0.5rem;
		}

		.title {
			padding-right: 2.5rem;
		}

		.content {
			@include truncate-margin;
		}
	}
}
</style>
